import { connect } from 'react-redux';
import {
  getEventNames,
  getMetainf,
  getRetentionComplexDimensionType,
  getRetentionComplexFirstEvent,
  getRetentionComplexOptions,
  getRetentionComplexReturnEvent,
} from '../../../reducers/analyticsApp';
import {
  changeDimensionType,
  changeFirstEvent,
  changeReturnEvent,
} from '../../../actions/retention/retentionComplex';
import RetentionComposeContainer from '../../../components/retention/complex/RetentionComposeContainer';

const mapStateToProps = (state) => ({
  events: getEventNames(state),
  options: getRetentionComplexOptions(state),
  dimensionType: getRetentionComplexDimensionType(state),
  firstEvent: getRetentionComplexFirstEvent(state),
  returnEvent: getRetentionComplexReturnEvent(state),
  getEventMetainf: (event) => getMetainf(state, event),
});

const mapDispatchToProps = {
  onDimensionTypeChange: changeDimensionType,
  onFirstEventChange: changeFirstEvent,
  onReturnEventChange: changeReturnEvent,
};

export default connect(mapStateToProps, mapDispatchToProps)(RetentionComposeContainer);
